<script lang="ts" setup>
defineProps<{
  title: string | null
}>()
</script>

<template>
  <h1 class="text-lg font-medium leading-[1.22] text-main-dark md:text-[22px] md:leading-[1.27]">
    {{ title }}
  </h1>
</template>
